import React, { useState, useEffect } from "react";
import { auth } from "../firebase"; // Import Firebase auth
import "../styles/Intro.css";
import WomenSchemes from "./WomenScheme";
import MenScheme from "./MenScheme";

function GovScheme() {
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Listen for authentication state changes
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  // Prevent button clicks if user is not logged in
  const handleSchemeSelection = (scheme) => {
    if (!user) {
      alert("Please sign in to view government schemes.");
      return;
    }
    setSelectedScheme(scheme);
  };

  return (
    <div>
      <div className="button-group">
        <button className="btn" onClick={() => handleSchemeSelection("women")}>
          Women Scheme
        </button>
        <button className="btn" onClick={() => handleSchemeSelection("men")}>
          Men Scheme
        </button>
      </div>

      <div className="content">
        {selectedScheme === "women" && user && <WomenSchemes />}
        {selectedScheme === "men" && user && <MenScheme />}
      </div>
    </div>
  );
}

export default GovScheme;
